import PayrollLayout from '../../components/layout/PayrollLayout';
import DeptMessages from '../../components/DeptMessages';

export default function PayMessagesPage() {
  return (
    <PayrollLayout>
      <DeptMessages dept="Payroll" color="emerald" testPrefix="pay" />
    </PayrollLayout>
  );
}
